import React from 'react';
import { CtaButton } from '../CtaButton';
import { ProductImage } from '../ProductImage';
import { PriceBlock } from '../PriceBlock';
import { BRAND, CORE_PROMISE } from '../../data/salesContent';
export function FinalCtaSection() {
  return <section className="bg-ink px-5 pb-12 pt-20 md:pt-28" data-id="element-117" data-mp="2ik0yq7jl8krg">
      <div className="mx-auto max-w-3xl text-center" data-id="element-118" data-mp="2dj3lm9dfqgwt">
        <ProductImage className="mx-auto w-full max-w-xl" data-id="element-119" data-mp="2dlg1mgzmuh78" />
        <p className="mt-12 text-sm font-bold uppercase tracking-[0.25em] text-gold md:text-base" data-id="element-120" data-mp="2ri2zqn3bndeq">{BRAND} presenta</p>
        <p className="mt-3 font-display text-base font-extrabold uppercase tracking-[0.15em] text-neutral-300 md:text-lg" data-id="element-121" data-mp="2mji6j7mhltzs">
          Primeros Auxilios para Instructores™
        </p>
        <h2 className="mt-5 font-display text-4xl font-black uppercase leading-tight text-cream md:text-6xl" data-id="element-122" data-mp="2waw61fefutsx">{CORE_PROMISE}</h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-neutral-400 md:text-xl" data-id="element-123" data-mp="3a9vualy1h6ok">
          Tené en un solo sistema el método, los contenidos, las prácticas, las simulaciones, las evaluaciones y las herramientas
          necesarias para organizar tus capacitaciones.
        </p>
        <p className="mt-10 font-display text-base font-extrabold uppercase tracking-widest text-cream md:text-lg" data-id="element-124" data-mp="262g16t7m7jym">3 volúmenes + 5 bonos</p>
        <div className="mt-2" data-id="element-125" data-mp="2g02mbxfic7r1">
          <PriceBlock data-id="element-126" data-mp="2g159bu9plq1o" />
        </div>
        <div className="mt-10" data-id="element-127" data-mp="2fy9e4dp8xfgx">
          <CtaButton data-id="element-128" data-mp="2kzynlowtll2w">Quiero dejar de preparar todo desde cero</CtaButton>
        </div>
      </div>
      <footer className="mx-auto mt-24 max-w-4xl border-t border-ink-line pt-8 text-center" data-id="element-129" data-mp="2p0ikqshe8op1">
        <p className="font-display text-lg font-extrabold tracking-wide text-gold" data-id="element-130" data-mp="2ts0n9kz2exc4">{BRAND}</p>
        <p className="mt-2 text-sm text-neutral-500" data-id="element-131" data-mp="2yqk9lmhkmb50">© 2026 {BRAND} · Primeros Auxilios para Instructores™ · Todos los derechos reservados</p>
      </footer>
    </section>;
}